import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CloudDownload, Loader2, AlertTriangle } from "lucide-react";
import { usePublishSync, runBootstrap, envLabel } from "@/components/PublishSyncCard";

const fmtDT = (iso) => { try { return iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "long", hour: "2-digit", minute: "2-digit" }) : ""; } catch { return iso || ""; } };

export default function PublishSyncBanner() {
  const [status, reload] = usePublishSync(60000);
  const [busy, setBusy] = useState(false);
  if (!status || !status.bootstrap_pending) return null;
  const m = status.pending_manifest;
  return (
    <div className="flex flex-wrap items-center gap-2 px-4 py-2 text-sm bg-amber-100 text-amber-900 border-b border-amber-300" data-testid="sync-banner">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-[220px]">
        <b>Bu ortam ({envLabel(status.env)}) henüz {envLabel(status.remote)} ile eşitlenmedi.</b> {envLabel(status.remote)} anlık görüntüsü: {fmtDT(m?.created_at)} · {(m?.total_docs || 0).toLocaleString("tr-TR")} kayıt.
      </span>
      <Button size="sm" className="h-8" disabled={busy} onClick={async () => { setBusy(true); const ok = await runBootstrap("restore", status); if (!ok) setBusy(false); }} data-testid="sync-banner-restore">
        {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <CloudDownload className="h-4 w-4 mr-1.5" />}{envLabel(status.remote)} verileriyle eşitle
      </Button>
      <Button size="sm" variant="ghost" className="h-8" disabled={busy} onClick={async () => { setBusy(true); await runBootstrap("keep", status); setBusy(false); reload(); }} data-testid="sync-banner-keep">Mevcut verilerle devam</Button>
    </div>
  );
}
